import ProductListPriceQuery from 'Query/ProductListPrice.query';
import { updateProductList } from 'Store/ProductList/ProductList.action';
import { makeCancelable } from 'Util/Promise';
import { Field, prepareQuery } from 'Util/Query';
import { QueryDispatcher } from 'Util/Request';
import { hash } from 'Util/Request/Hash';
import { executeGet, listenForBroadCast } from 'Util/Request/Request';
/**
 * Products Price Dispatcher
 * @class ProductsPriceDispatcher
 * @extends ProductsPriceDispatcher
 * @namespace Bodypwa/Store/ProductsPrice/Dispatcher */
export class ProductsPriceDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct('ProductsPrice');
    }

    onSuccess(data, dispatch, options) {
        const { products: { items } } = data;
        const { args: { currentPage: page, filter: { categoryIds } = {}, search } } = options;
        /**
         * In case there are no items, or item count is
         * smaller then 0 => the product was not found.
         */
        if (!items || items.length <= 0) {
            return;
        }
        const id = categoryIds || search;

        dispatch(updateProductList({ productsList: items, page }, id));
    }

    onError(_) {
        console.log('Error', _);
    }

    prepareRequest(options) {
        return ProductListPriceQuery.getQuery(options);
    }

    handleData(dispatch, options) {
        const { cacheTTL } = this;
        const { args } = options;

        const name = `ProductsPrice${ hash(JSON.stringify(args)) }`;
        const rawQueries = this.prepareRequest(options, dispatch);

        if (!rawQueries) {
            return;
        }

        const queries = rawQueries instanceof Field ? [rawQueries] : rawQueries;

        if (this.promise) {
            this.promise.cancel();
        }

        this.promise = makeCancelable(
            new Promise((resolve, reject) => {
                executeGet(prepareQuery(queries), name, cacheTTL)
                    .then(
                    /** @namespace Bodypwa/Store/ProductsPrice/Dispatcher/ProductsPriceDispatcher/handleData/makeCancelable/executeGet/then/resolve */
                        (data) => resolve(data),
                        /** @namespace Bodypwa/Store/ProductsPrice/Dispatcher/ProductsPriceDispatcher/handleData/makeCancelable/executeGet/then/reject/catch */
                        (error) => reject(error)
                    );
            })
        );

        this.promise.promise.then(
        /** @namespace Bodypwa/Store/ProductsPrice/Dispatcher/ProductsPriceDispatcher/handleData/then */
            (data) => this.onSuccess(data, dispatch, options),
            /** @namespace Bodypwa/Store/ProductsPrice/Dispatcher/ProductsPriceDispatcher/handleData/then/catch */
            (error) => this.onError(error, dispatch, options),
        );

        listenForBroadCast(name).then(
        /** @namespace Bodypwa/Store/ProductsPrice/Dispatcher/ProductsPriceDispatcher/handleData/listenForBroadCast/then */
            (data) => this.onUpdate(data, dispatch, options),
        );
    }
}

export default new ProductsPriceDispatcher();
